<ada-resize-sensor (resize)="resizeCanvas($event)"></ada-resize-sensor>
<a
	#CanvasEventTarget
	class="ada-full-width ada-display-block"
	id="ada-memory-pipeline-target"
	href="javascript:void(0)"
	tabindex="0"
>
	<canvas
		#Canvas
		ada-background-color="background-3"
	></canvas>
</a>
